// Delta event types the editor emits and ActivityState observers consume.
// Values are the on-the-wire `type` strings; keep in sync with the editor wiring
// that calls ActivityState.notify().

const DELTA_TYPES = Object.freeze({
    BLOCK_PLACED: 'block-placed',
    BLOCK_REMOVED: 'block-removed',
    SPRITE_SELECTED: 'sprite-selected',
    PAGE_CHANGED: 'page-changed',
    RUN_STARTED: 'run-started',
    RUN_COMPLETED: 'run-completed',
    IDLE_THRESHOLD_CROSSED: 'idle-threshold-crossed'
});

const DELTA_TYPE_VALUES = Object.freeze(Object.keys(DELTA_TYPES).map((k) => DELTA_TYPES[k]));

module.exports = {
    DELTA_TYPES,
    DELTA_TYPE_VALUES
};
